import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import ScrollToTop from "@/components/base/ScrollToTop";

export default function About() {
  const breadcrumbItems = [
    { label: "首页", href: "/" },
    { label: "关于我们" },
  ];

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "韩漫大全",
    url: "https://www.manhwadaquan.com/",
    description:
      "韩漫漫画网汇聚众多韩漫大全作品，推荐好看的韩国漫画免费在线观看，加载速度快画质清晰，是您探索韩漫世界的理想平台。",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      email: "contact@manhwadaquan.com",
      availableLanguage: ["Chinese"],
    },
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "韩漫大全上的漫画是否免费？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "是的，韩漫大全上所有韩国漫画均免费在线观看，无需注册或付费，随时随地畅享海量韩漫资源。",
        },
      },
      {
        "@type": "Question",
        name: "网站上的漫画更新频率如何？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "韩漫大全每日更新，紧跟韩国漫画最新连载进度，确保读者能在第一时间看到最新的韩漫章节。",
        },
      },
      {
        "@type": "Question",
        name: "需要注册账号才能阅读漫画吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "不需要。韩漫大全完全开放阅读，无需注册或登录，打开网站即可畅享所有韩国漫画内容。",
        },
      },
      {
        "@type": "Question",
        name: "如何搜索我想看的韩漫？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "您可以通过首页的分类导航浏览不同类型的韩漫，也可以使用搜索功能输入漫画名称或作者名进行查找。",
        },
      },
      {
        "@type": "Question",
        name: "韩漫大全支持移动设备阅读吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "当然支持。韩漫大全采用响应式设计，完美适配手机、平板和电脑等各种设备，让您随时随地畅享阅读体验。",
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />

      <main className="pt-20">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumbItems} />

          {/* Hero */}
          <section className="mt-8 text-center py-14 md:py-20">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 font-serif">
              关于<span className="text-primary-500">韩漫</span>大全
            </h1>
            <p className="mt-4 text-foreground-500 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
              韩漫大全致力于为广大韩漫爱好者提供优质的在线阅读体验。我们汇聚了海量韩国漫画资源，涵盖恋爱、奇幻、动作、悬疑等多种类型，每日更新，让您不错过任何精彩故事。
            </p>
          </section>

          {/* Brand Introduction */}
          <section className="py-12 border-t border-background-200/70">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-serif mb-8">
              <a id="brand">品牌介绍</a>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="p-6 rounded-xl bg-background-100/70 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-book-read-line text-2xl" />
                </div>
                <h3 className="mt-4 text-base font-semibold text-foreground-900">海量资源</h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  我们收录了上万部韩国漫画作品，涵盖恋爱、奇幻、动作、悬疑、搞笑、日常等多种类型，满足不同读者的喜好。无论是热门连载还是小众佳作，都能在这里找到。
                </p>
              </div>

              <div className="p-6 rounded-xl bg-background-100/70 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-speed-line text-2xl" />
                </div>
                <h3 className="mt-4 text-base font-semibold text-foreground-900">极速加载</h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  采用先进的图片优化和CDN加速技术，确保漫画页面快速加载。高清画质配合流畅的阅读体验，让您沉浸在精彩的韩漫世界中。
                </p>
              </div>

              <div className="p-6 rounded-xl bg-background-100/70 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                  <i className="ri-device-line text-2xl" />
                </div>
                <h3 className="mt-4 text-base font-semibold text-foreground-900">全平台支持</h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  支持电脑、平板和手机等多种设备访问，完美适配不同屏幕尺寸。无论身在何处，打开浏览器即可享受韩漫阅读的乐趣。
                </p>
              </div>
            </div>
          </section>

          {/* Reputation */}
          <section className="py-12 border-t border-background-200/70">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-serif mb-8">
              <a id="reputation">用户口碑</a>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {[
                {
                  name: "漫画爱好者小王",
                  rating: 5,
                  text: "韩漫大全真的是我用过最好的韩漫网站！更新速度超快，画质也很清晰，每天必刷。",
                },
                {
                  name: "韩剧迷小美",
                  rating: 5,
                  text: "从韩剧入坑韩漫，发现这个网站后根本停不下来。分类很全，找漫画特别方便。",
                },
                {
                  name: "资深读者老张",
                  rating: 4,
                  text: "收藏了很多冷门韩漫，资源非常丰富。加载速度快，阅读体验流畅，强烈推荐。",
                },
                {
                  name: "二次元少女",
                  rating: 5,
                  text: "画质高清，无广告打扰，免费观看实在太良心了！每天都在追最新的韩漫连载。",
                },
                {
                  name: "上班族小陈",
                  rating: 5,
                  text: "手机浏览体验很棒，通勤路上刷几话韩漫，已经成为每天的固定习惯了。",
                },
                {
                  name: "大学生小李",
                  rating: 4,
                  text: "室友推荐的这个网站，没想到资源这么全。最近迷上了几部恋爱韩漫，每天都追更新。",
                },
              ].map((review, index) => (
                <div
                  key={index}
                  className="p-5 rounded-xl bg-background-50 border border-background-200/70"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }, (_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${
                          i < review.rating
                            ? "ri-star-fill text-amber-400"
                            : "ri-star-line text-foreground-300"
                        }`}
                      />
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {review.text}
                  </p>
                  <p className="mt-3 text-xs font-medium text-foreground-800">
                    — {review.name}
                  </p>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-5">
              {[
                { value: "10,000+", label: "漫画作品" },
                { value: "500万+", label: "月活跃用户" },
                { value: "99.9%", label: "服务稳定性" },
                { value: "4.8", label: "用户评分" },
              ].map((stat, index) => (
                <div
                  key={index}
                  className="text-center p-5 rounded-xl bg-background-100/70 border border-background-200/70"
                >
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 font-serif">
                    {stat.value}
                  </div>
                  <div className="mt-1 text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          {/* FAQ */}
          <section className="py-12 border-t border-background-200/70">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-serif mb-8">
              <a id="faq">常见问题</a>
            </h2>
            <div className="max-w-3xl space-y-3">
              {[
                {
                  q: "韩漫大全上的漫画是否免费？",
                  a: "是的，韩漫大全上所有韩国漫画均免费在线观看，无需注册或付费，随时随地畅享海量韩漫资源。",
                },
                {
                  q: "网站上的漫画更新频率如何？",
                  a: "韩漫大全每日更新，紧跟韩国漫画最新连载进度，确保读者能在第一时间看到最新的韩漫章节。",
                },
                {
                  q: "需要注册账号才能阅读漫画吗？",
                  a: "不需要。韩漫大全完全开放阅读，无需注册或登录，打开网站即可畅享所有韩国漫画内容。",
                },
                {
                  q: "如何搜索我想看的韩漫？",
                  a: "您可以通过首页的分类导航浏览不同类型的韩漫，也可以使用搜索功能输入漫画名称或作者名进行查找。",
                },
                {
                  q: "韩漫大全支持移动设备阅读吗？",
                  a: "当然支持。韩漫大全采用响应式设计，完美适配手机、平板和电脑等各种设备，让您随时随地畅享阅读体验。",
                },
                {
                  q: "如何联系韩漫大全的运营团队？",
                  a: "您可以通过下方的联系表单或发送邮件至 contact@manhwadaquan.com 与我们取得联系，我们会在24小时内回复。",
                },
              ].map((faq, index) => (
                <details
                  key={index}
                  className="group rounded-xl border border-background-200/70 overflow-hidden"
                >
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-50 transition-colors">
                    <span className="text-sm font-medium text-foreground-800 pr-4">
                      {faq.q}
                    </span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0" />
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="py-12 border-t border-background-200/70">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-serif mb-8">
              <a id="contact">联系我们</a>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              <div>
                <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们。我们期待您的来信！
                </p>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className="ri-mail-line text-lg" />
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">邮箱</p>
                      <p className="text-sm font-medium text-foreground-800">
                        contact@manhwadaquan.com
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                      <i className="ri-customer-service-line text-lg" />
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">客服时间</p>
                      <p className="text-sm font-medium text-foreground-800">
                        周一至周日 9:00 - 21:00
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <form
                  id="contact-form"
                  data-readdy-form
                  className="space-y-4"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const formData = new FormData(form);
                    const honeypot = formData.get("website_alt") as string;
                    if (honeypot && honeypot.trim() !== "") {
                      const successEl = document.getElementById("form-success");
                      if (successEl) successEl.classList.remove("hidden");
                      return;
                    }
                    try {
                      const res = await fetch(
                        "https://readdy.ai/api/form/d9otrmiftmtnfcfh0e4g",
                        {
                          method: "POST",
                          headers: { "Content-Type": "application/x-www-form-urlencoded" },
                          body: new URLSearchParams(
                            Array.from(formData.entries()).filter(
                              ([k]) => k !== "website_alt"
                            ) as [string, string][]
                          ).toString(),
                        }
                      );
                      const text = await res.text();
                      let parsed;
                      try {
                        parsed = JSON.parse(text);
                      } catch {
                        parsed = null;
                      }
                      if (res.ok && parsed?.code === "OK") {
                        const successEl = document.getElementById("form-success");
                        if (successEl) successEl.classList.remove("hidden");
                        const errorEl = document.getElementById("form-error");
                        if (errorEl) errorEl.classList.add("hidden");
                        form.reset();
                      } else {
                        const errorEl = document.getElementById("form-error");
                        if (errorEl) {
                          errorEl.classList.remove("hidden");
                          const msgEl = document.getElementById("form-error-msg");
                          if (msgEl)
                            msgEl.textContent =
                              parsed?.meta?.message ||
                              parsed?.message ||
                              parsed?.meta?.detail ||
                              "提交失败，请稍后重试。";
                        }
                      }
                    } catch {
                      const errorEl = document.getElementById("form-error");
                      if (errorEl) {
                        errorEl.classList.remove("hidden");
                        const msgEl = document.getElementById("form-error-msg");
                        if (msgEl) msgEl.textContent = "网络错误，请检查网络连接后重试。";
                      }
                    }
                  }}
                >
                  <div>
                    <label
                      htmlFor="contact-name"
                      className="block text-sm font-medium text-foreground-700 mb-1"
                    >
                      姓名
                    </label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="contact-email"
                      className="block text-sm font-medium text-foreground-700 mb-1"
                    >
                      邮箱
                    </label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="contact-message"
                      className="block text-sm font-medium text-foreground-700 mb-1"
                    >
                      留言内容
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                      placeholder="请输入您的留言（500字以内）"
                    />
                  </div>
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <button
                    type="submit"
                    className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
                  >
                    发送消息
                  </button>
                  <div
                    id="form-success"
                    className="hidden mt-3 p-3 rounded-lg bg-secondary-100/70 text-secondary-700 text-sm text-center"
                  >
                    消息已发送成功！我们会尽快回复您。
                  </div>
                  <div
                    id="form-error"
                    className="hidden mt-3 p-3 rounded-lg bg-accent-100/70 text-accent-700 text-sm text-center"
                  >
                    <span id="form-error-msg">提交失败，请稍后重试。</span>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}